import type { SYSAction } from "../../../../../../../_ovlclient/src"
import { TableRefresh } from "../../../../../../../_ovlclient/src/library/table/tableapi"

const HookScreenRefresh: SYSAction = async (_) => {
  await TableRefresh("PKGPackaging", { suppressBusySnack: true })
}

const HookScreenNavigateIn = async (_) => {
  await TableRefresh("PKGPackaging")
}
let hooks = { HookScreenNavigateIn, HookScreenRefresh }
export let PKGPackagingCustomerChooser = { hooks }
